import Header from './components/Header';
import Hero from './components/Hero';
import SectionAbout from './components/SectionAbout';
import SectionCarousel from './components/SectionCarousel';
import SectionTopics from './components/SectionTopics';
import SectionCards from './components/SectionCards';
import SectionFAQ from './components/SectionFAQ';
import SectionContact from './components/SectionContact';
import SectionComments from './components/SectionComments';
import SectionMedia from './components/SectionMedia';
import SectionIndex from './components/SectionIndex';
import SectionRanking from './components/SectionRanking';
import SectionFeatures from './components/SectionFeatures';
import SectionApp from './components/SectionApp';
import SectionUpdates from './components/SectionUpdates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionAbout />
        <SectionCarousel />
        <SectionTopics />
        <SectionCards />
        <SectionFAQ />
        <SectionContact />
        <SectionComments />
        <SectionMedia />
        <SectionIndex />
        <SectionRanking />
        <SectionFeatures />
        <SectionApp />
        <SectionUpdates />
      </main>
      <Footer />
    </>
  );
}